import React, { useState, useEffect } from "react";
import { useParams } from "react-router";
import { FeedAPI } from "pages/feed/feed.service";
import FeedCard from "pages/feed/feedCard";
import { KoLoader } from "packages";

export default function PublicFeedCard() {
  let { feedId } = useParams();
  const [post, setPost] = useState({});
  const [loading, setLoading] = useState(true);

  const getFeedById = async(fid) => {
    setLoading(true);
    try {
      const fetchedPost = await FeedAPI.getFeedById(fid);
      setPost(fetchedPost['feed']);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
    }
  };



  useEffect(() => {
    getFeedById(feedId);
  }, [feedId]);


  return (
    <div style={{ maxWidth: '90vw', margin: '0 auto', padding: '3rem', fontSize: '1.3rem' }}>
      {loading && <KoLoader />}
      <FeedCard post={post} isHideActions={true} />
    </div>
  );
}
